
import getEnvironment from '../../../env';
import { RequestMutationWrapper } from '../../../models/API/RequestMutationWrapper';
import { OrganisationContact } from '../../../models/OrganisationContact';
import HandleQuery from '../../../redux/EndpointQueryHandler';
import { GetManyPackage } from '../../../redux/GetManyPackage';
import handleResponse from '../../../redux/handleResponse';
import { portalApiSlice } from '../../../redux/portalApiSlice';
import { transformMultipleResponseToRightType, transformSingleResponseToRightType } from '../../../redux/transformResponse';

const baseurl = getEnvironment().REACT_APP_API_BASEURL;

export const organisationContactApiSlice = portalApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOrganisationContactsByOrganisationId: builder.query<OrganisationContact[], GetManyPackage>({
      query: (pack) => HandleQuery({
        url: `${baseurl}/organisations/${pack.uuid}/organisation-contacts`,
        responseHandler: (res) => handleResponse({ response: res, toastWithResult: false, toastErrorText: "Organisation contacts could not be fetched" }),
        pagination: pack.pagination
      }),
      transformResponse: (a: OrganisationContact[], b, c) => transformMultipleResponseToRightType(OrganisationContact, a, b, c),
      providesTags: [
        'organisationContacts'
      ]
    }),
    addOrganisationContact: builder.mutation<OrganisationContact, RequestMutationWrapper<OrganisationContact>>({
      query: (request) => HandleQuery({
        url: `${baseurl}/organisations/${request.parentId}/organisation-contacts`,
        responseHandler: (res) => handleResponse({ response: res, toastSuccessText: "Organisation contact was created", toastErrorText: "Organisation contact could not be created" }),
        method: 'POST',
        body: request.data,
      }),
      transformResponse: (a: OrganisationContact, b, c) => transformSingleResponseToRightType(OrganisationContact, a, b, c),

      invalidatesTags: ['organisationContacts', 'organisations'],
    }),
    updateOrganisationContact: builder.mutation<OrganisationContact, RequestMutationWrapper<OrganisationContact>>({
      query: (request) => HandleQuery({
        url: `${baseurl}/organisation-contacts/${request.data.uuid}`,
        responseHandler: (res) => handleResponse({ response: res, toastSuccessText: "Organisation contact was updated", toastErrorText: "Organisation contact could not be updated" }),
        method: "PATCH",
        body: request.data
      }),
      transformResponse: (a: OrganisationContact, b, c) => transformSingleResponseToRightType(OrganisationContact, a, b, c),
      invalidatesTags: ['organisationContacts', 'organisations'],
    }),
    deleteOrganisationContact: builder.mutation<void, RequestMutationWrapper<OrganisationContact>>({
      query: (request) => HandleQuery({
        url: `${baseurl}/organisation-contacts/${request.data.uuid}`,
        method: 'DELETE',
        responseHandler: (res) => handleResponse({ response: res, toastSuccessText: "Organisation contact was deleted", toastErrorText: "Organisation contact could not be deleted" }),
      }),

      invalidatesTags: ['organisationContacts', 'organisations'],
    }),
  })
})


export const { useGetOrganisationContactsByOrganisationIdQuery, useAddOrganisationContactMutation, useUpdateOrganisationContactMutation, useDeleteOrganisationContactMutation } = organisationContactApiSlice
















